import React from 'react';
import { FieldPath } from 'react-hook-form';
import { z } from 'zod';

export const UsedFieldsContext = React.createContext<React.RefObject<FieldPath<z.infer<z.AnyZodObject>>[]> | null>(null);
